import { createFileRoute } from "@tanstack/react-router";
import { MessageCircle, Mail, MapPin, Clock } from "lucide-react";
import { useTranslation } from "react-i18next";
import { buildWhatsAppUrl, WHATSAPP_NUMBER, isWhatsAppConfigured } from "@/lib/whatsapp";

export const Route = createFileRoute("/contact")({
  head: () => ({
    meta: [
      { title: "Contact Bacha Way Travel | 24/7 Support in Morocco" },
      { name: "description", content: "Contact Bacha Way Travel by WhatsApp, phone or email. 24/7 customer support for private airport transfers across Morocco." },
      { property: "og:title", content: "Contact Bacha Way Travel" },
      { property: "og:description", content: "WhatsApp 24/7, email, and our office in Morocco." },
      { property: "og:url", content: "https://bachawaytravel.com/contact" },
    ],
    links: [{ rel: "canonical", href: "https://bachawaytravel.com/contact" }],
  }),
  component: ContactPage,
});

function ContactPage() {
  const { t } = useTranslation();
  const waUrl = buildWhatsAppUrl("Hello Bacha Way Travel, I'd like to ask about a transfer.");
  return (
    <div className="mx-auto max-w-4xl px-6 py-16 md:py-24">
      <div className="text-xs uppercase tracking-[0.2em] text-primary">{t("contact.eyebrow")}</div>
      <h1 className="mt-3 font-display text-5xl md:text-6xl">Contact Bacha Way Travel</h1>
      <p className="mt-5 max-w-2xl text-muted-foreground">{t("contact.lead")}</p>

      <div className="mt-12 grid gap-5 md:grid-cols-2">
        <a href={waUrl} target="_blank" rel="noopener noreferrer"
          className="group flex items-start gap-5 rounded-2xl border border-primary/30 bg-primary/5 p-6 hover:bg-primary/10 transition-colors">
          <MessageCircle className="h-7 w-7 text-primary mt-1" />
          <div>
            <div className="font-medium text-foreground">{t("contact.wa")}</div>
            <div className="text-sm text-muted-foreground mt-1">{isWhatsAppConfigured() ? `+${WHATSAPP_NUMBER}` : t("contact.waTap")}</div>
            <div className="text-xs text-primary mt-3 group-hover:underline">{t("contact.waOpen")}</div>
          </div>
        </a>

        <a href="mailto:booking@bachawaytravel.com"
          className="flex items-start gap-5 rounded-2xl border border-border bg-card p-6 hover:border-primary/40 transition-colors">
          <Mail className="h-7 w-7 text-primary mt-1" />
          <div>
            <div className="font-medium text-foreground">{t("contact.email")}</div>
            <div className="text-sm text-muted-foreground mt-1">booking@bachawaytravel.com</div>
            <div className="text-xs text-muted-foreground mt-3">{t("contact.emailSub")}</div>
          </div>
        </a>

        <div className="flex items-start gap-5 rounded-2xl border border-border bg-card p-6">
          <MapPin className="h-7 w-7 text-primary mt-1" />
          <div>
            <div className="font-medium text-foreground">{t("contact.based")}</div>
            <div className="text-sm text-muted-foreground mt-1">{t("contact.basedSub")}</div>
          </div>
        </div>

        <div className="flex items-start gap-5 rounded-2xl border border-border bg-card p-6">
          <Clock className="h-7 w-7 text-primary mt-1" />
          <div>
            <div className="font-medium text-foreground">{t("contact.hours")}</div>
            <div className="text-sm text-muted-foreground mt-1">{t("contact.hoursSub")}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
